import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/logo-dark.svg'
import _imports_1 from '@/assets/img/logo-icon.svg'


const _hoisted_1 = { class: "navbar bar fixed z-50" }
const _hoisted_2 = { class: "navbar-start" }
const _hoisted_3 = {
  key: 0,
  class: "logo",
  src: _imports_0,
  alt: "viaphoton logo",
  "data-cy": "logo"
}
const _hoisted_4 = {
  key: 1,
  class: "logo logo-icon",
  src: _imports_1,
  alt: "viaphoton logo",
  "data-cy": "logo"
}
const _hoisted_5 = { class: "title-text" }
const _hoisted_6 = {
  key: 0,
  class: "brand-sep"
}
const _hoisted_7 = { class: "crumb-page" }
const _hoisted_8 = { class: "navbar-end mr-2" }
const _hoisted_9 = {
  key: 0,
  class: "env-banner"
}
const _hoisted_10 = {
  key: 1,
  class: "dropdown dropdown-end"
}
const _hoisted_11 = {
  tabindex: "0",
  class: "btn btn-ghost btn-circle avatar w-10"
}
const _hoisted_12 = { class: "rounded-full" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "flex flex-row hero-content px-6" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "username font-normal" }
const _hoisted_17 = { class: "email font-normal" }
const _hoisted_18 = { key: 2 }

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAuth0 } from '@auth0/auth0-vue';
import config from '@/config';
import { useIsMobile } from '@/composables/useIsMobile';
import { getPageTitle } from '@/utils/navigationMenu';


export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const isMobile = useIsMobile();

// Current page name, resolved from the shared nav definition (child routes
// like SO details / price-list forms map to their parent flow's entry).
const route = useRoute();
const pageTitle = computed(() => getPageTitle(route.name));

const { user, logout } = useAuth0();
const onLogout = () => logout({ logoutParams: { returnTo: window.location.origin } });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "home-link",
        "data-cy": "home-link"
      }, {
        default: _withCtx(() => [
          (!_unref(isMobile))
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : (_openBlock(), _createElementBlock("img", _hoisted_4)),
          _createElementVNode("span", _hoisted_5, [
            (!_unref(isMobile))
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "|"))
              : _createCommentVNode("", true),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "brand" }, "Pricing Engine", -1))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_toolbar_title, {
        class: "title-text",
        "data-cy": "toolbar-title"
      }, {
        default: _withCtx(() => [
          (pageTitle.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "crumb-sep" }, "/", -1)),
                _createElementVNode("span", _hoisted_7, _toDisplayString(pageTitle.value), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_unref(config).appEnv !== 'prod')
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(isMobile) ? _unref(config).appEnv.toUpperCase() : `Environment: ${_unref(config).appEnv.toUpperCase()}`), 1))
        : _createCommentVNode("", true),
      (_unref(user))
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("img", {
                  class: "w-14",
                  src: _unref(user).picture
                }, null, 8, _hoisted_13)
              ])
            ]),
            _createElementVNode("ul", {
              tabindex: "0",
              class: _normalizeClass([
            !_unref(user).email ? 'w-60' : 'w-auto',
            'p-2 shadow-lg menu menu-compact dropdown-content bg-white rounded-md text-neutral',
          ])
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("img", {
                  src: _unref(user).picture,
                  class: "rounded-full w-10 shadow-2xl"
                }, null, 8, _hoisted_15),
                _createElementVNode("div", null, [
                  _createElementVNode("h1", _hoisted_16, _toDisplayString(_unref(user)?.name), 1),
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(user)?.email), 1)
                ])
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "mt-1" }, null, -1)),
              _createElementVNode("li", {
                onClick: onLogout,
                class: "text-sm text-neutral p-3 cursor-pointer hover:bg-base-100"
              }, "Logout")
            ], 2)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_router_link, { to: "/login" }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("button", { class: "btn btn-circle btn-sm rounded-full btn-primary text-base text-neutral" }, [
                  _createElementVNode("i", { class: "fa-solid fa-right-to-bracket" })
                ], -1)
              ])),
              _: 1
            })
          ]))
    ])
  ]))
}
}

})